import { render, staticRenderFns } from "./DevicesList.vue?vue&type=template&id=d5810ce0"
import script from "./DevicesList.vue?vue&type=script&lang=js"
export * from "./DevicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports